/**
 * Role keys must match server `server/lib/roles.js` VALID_ROLES exactly.
 */
/** Same set as server PIN_LOGIN_ROLES — PIN-only login at terminal (not Admin / Accountant). */
export const POS_PIN_ROLES = ['Cashier', 'Store Manager', 'Order Creator', 'Franchise Admin'];

/** Default landing after PIN login (Order Creator should go to OMS, not POS). */
export const POS_HOME_ROLES = ['Cashier', 'Store Manager', 'Franchise Admin'];

export const ROLE_ORDER = [
  'Admin',
  'Order Creator',
  'Store Manager',
  'Accountant',
  'Cashier',
  'Franchise Admin'
];

export const ROLE_META = {
  Admin: {
    label: 'Admin',
    short: 'Full system access',
    description:
      'Owner / HQ: all orders, analytics, users, POS, CRM, catalog, and brand-wide dashboards.'
  },
  'Order Creator': {
    label: 'Order Creator',
    short: 'OMS & catalog',
    description: 'Create and manage delivery and kitchen orders; same tools as today.'
  },
  'Store Manager': {
    label: 'Store Manager',
    short: 'Fulfilment & counter',
    description: 'Store fulfilment view, delivery challan, and day-to-day store operations.'
  },
  Accountant: {
    label: 'Accountant',
    short: 'Payments & settlement',
    description: 'Payments, settlement, and financial views (unchanged).'
  },
  Cashier: {
    label: 'Cashier',
    short: 'POS terminal',
    description:
      'Counter billing and cake orders. Quick 4-digit PIN login at the terminal; assign outlets below.'
  },
  'Franchise Admin': {
    label: 'Franchise / store admin',
    short: 'One store or territory',
    description:
      'Heads: orders, POS, CRM for assigned outlets, reports for those stores. Assign at least one outlet.'
  }
};
